export const DEFAULT_LOADER_ICON = 'butterfly'

export const LOADER_ICON_CONFIGS = {
  'EBT': 'butterfly',
  'PRV': 'flower',
  'VEX': 'butterfly',
  'VP': 'butterfly'
}
